import createAction from '../../../utils/redux-helpers/createAction';

const handler = state =>
  state.removeIn(['customer', 'pendingVerificationOrder']);

export const hideResentLink = createAction({
  action: ['hideResentLink'],
  handler,
});
